export default {
  list: null,
  activeProfileId: null
};
